module.exports = __webpack_public_path__ + "img/LogoKarateDay2021.77ade419.svg";